import React from "react";
import { useTranslation } from "react-i18next";
import { useFormikContext } from "formik";
import { useSelector } from "react-redux";

import FormikDateInput from "components/InputsField/formikInputs/FormikDateField";
import AsyncSelect from "components/InputsField/formikInputs/AsyncSelect";
import ExtraOptions from "components/FreightComponents/ExtraOptions";
import Dimensions from "components/FreightComponents/Dimensions";
import Title from "components/common/Layout/Title";
import { UTILS } from "endpointsConst";

import styles from "./styles.module.scss";

const SearchOptions = ({ isOpen }) => {
    const { t } = useTranslation();
    const { values } = useFormikContext();
    const lang = useSelector((state) => state.settings.lang);

    return (
        <>
            <div className={styles.searchRow}>
                <div className={styles.datesGroup}>
                    <FormikDateInput
                        name="loading_from"
                        label={t("cargoSearch.main.date")}
                        placeholderText={t("cargoSearch.size_field.grey_from")}
                        minDate={new Date(Date.now())}
                        maxDate={values.loading_to ? new Date(values.loading_to) : null}
                    />
                    <span className={styles.dateSeparator} />
                    <FormikDateInput
                        label={t("cargoSearch.main.date_unloading")}
                        name="loading_to"
                        placeholderText={t("cargoSearch.size_field.grey_till")}
                        minDate={
                            values.loading_from ? new Date(values.loading_from) : new Date(Date.now())
                        }
                    />
                </div>
                <div className={styles.selectsGroup}>
                    <div className={styles.selectField}>
                        <AsyncSelect
                            url={`${UTILS}/transport-bodytypes/?lang=${lang}`}
                            label={t("cargoSearch.main.body")}
                            name="transport_bodytype_ids"
                            isClearable={true}
                            sort
                            isMulti
                        />
                    </div>
                    <div className={styles.selectField}>
                        <AsyncSelect
                            url={`${UTILS}/loadingTypes/?lang=${lang}`}
                            label={t("cargoSearch.main.loading_type")}
                            name="loading_type_ids"
                            isClearable={true}
                            isMulti
                            maxDisplayedValues={2}
                        />
                    </div>
                </div>
            </div>
            {isOpen && (
                <>
                    <Title withMargin>{t("cargoSearch.additional_field.heading")}</Title>
                    <ExtraOptions />
                    <Title withMargin>{t("cargoSearch.size_field.heading")}</Title>
                    <Dimensions />
                </>
            )}
        </>
    );
};

export default SearchOptions;
